import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class ImageASearchComponent extends BridgeComponent {
    static component = "imagesearch";

    connect() {
        super.connect();
        this.element.addEventListener("click", this.#handleClick);
    }

    #handleClick = () => {
        this.send("start", {}, (response) => {
            const base64 = response.data?.imageBase64;

            if (!base64) {
                window.triggerToast('No image data received', 'error');
                return;
            }

            this.#searchWithImage(base64);
        });
    };

    #searchWithImage(base64Image) {
        const searchUrl = `${window.origin}/ethereal-theme/wp-json/wktfs/v1/search-url`;

        fetch(
            "https://wordpressdemo.webkul.com/ethereal-theme/wp-json/wktfs/v1/search-url",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    image_data: base64Image,
                }),
            },
        )
            .then((res) => res.json())
            .then((data) => {
                const redirectUrl = data?.url; // Expecting { url: "https://..." }
                if (!redirectUrl) {
                    window.triggerToast('No redirect URL in response', 'error');
                    return;
                }

                if (window.Turbo) {
                    Turbo.visit(redirectUrl);
                } else {
                    window.location.href = redirectUrl;
                }
            })
            .catch((err) => {
                console.error("❌ Image search error:", err);
                window.triggerToast('Image search failed.', 'error');
            });
    }

    disconnect() {
        this.element.removeEventListener("click", this.#handleClick);
    }
}

export default ImageASearchComponent;
